import {
  EMPTY_OBJECT,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../constants/common'
import { ListItem } from '../../ListItem'
import { TasksWidgetItemContent } from '../TasksWidgetItemContent'

import * as styles from './TasksWidgetItem.module.css'

import TaskIcon from '../../../icons/task.svg'

function TasksWidgetItem({
  className = styles.TasksWidgetItem,
  contentContainerProps: {
    className: contentContainerClassName = styles.contentContainer,
    ...contentContainerProps
  } = EMPTY_OBJECT,
  hoverClassName = styles.hover,
  ...restProps
}) {
  return (
    <ListItem
      {...restProps}
      Content={TasksWidgetItemContent}
      ListIcon={TaskIcon}
      className={className}
      contentContainerProps={{
        ...contentContainerProps,
        className: contentContainerClassName,
      }}
      hoverClassName={hoverClassName}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
    />
  )
}

export default TasksWidgetItem
